import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import firebase from './plugins/firebase'
import axios from 'axios'

import VueI18n from 'vue-i18n'
import ja from './language/ja.json'
import en from './language/en.json'
import zh from './language/zh.json'
import ko from './language/ko.json'

// import { fire } from '@/utils/logger';
import {
  fire,
  deviceId,
  markSessionStart,
  isNewSession
} from '@/utils/logger';
import {
  readViewport
} from '@/utils/viewport';


Vue.prototype.$axios = axios

Vue.config.productionTip = false

Vue.use(VueI18n)


const saved = localStorage.getItem('locale') // ユーザーが前回選んだ言語を localStorage に保存してあるかを取得
const browser = (navigator.language || 'ja').slice(0, 2) // ブラウザの言語設定を取得（例: 'ja-JP' → 'ja'、'en-US' → 'en'）
const fallback = 'ja' // もし何もなければ 'ja' を使うことにする
// 1. localStorage に保存されていればそれを使う
// 2. 保存されていなければブラウザ言語が ['ja','en','zh','ko'] に含まれていればそれを使う
// 3. それ以外なら fallback（'ja'）を使う
const startLocale = saved || (['ja', 'en', 'zh', 'ko'].includes(browser) ? browser : fallback)

const i18n = new VueI18n({
  locale: startLocale,
  fallbackLocale: 'en',
  messages: {
    ja,
    en,
    zh,
    ko,
  },
  silentFallbackWarn: true
});

(async () => {
  try {
    // 起動時に“現在ロケールの辞書”を必ずロード（超重要）
    // ※ loadPenguinLocale の中で localeStamp を更新する実装にしておくとベスト
    await store.dispatch('loadPenguinLocale', startLocale);
    // （必要なら）日本語逆引きなどを先に構築
    // await store.dispatch('buildJaReverseMap');
    await firebase(); //認証状態が確定するのを待つ（自動ログインでも uid が確定）
  } catch (e) {
    console.warn('[bootstrapLocale] failed:', e);
  }

  // 新セッションなら session_start と viewport を1回だけ送る
  router.beforeEach((to, from, next) => {
    if (isNewSession()) {
      markSessionStart(); // 開始時刻を記録
      const sid = sessionStorage.getItem('session_id');
      sessionStorage.setItem('sent_session_start_for_' + sid, '1'); // 多重送信防止

      fire('session_start', {
        device_id: deviceId,
        app_version: process.env.VUE_APP_VERSION || 'dev',
        locale: localStorage.getItem('locale') || navigator.language || 'ja',
        aquarium: to.params?.aquarium || '(unknown)',
        uid: store.state.user?.uid || null,
        referer: document.referrer || null,
      });

      // セッション開始と同じタイミングで viewport を1回
      fire('viewport', readViewport());
    }
    next();
  });

  new Vue({
    router,
    store,
    vuetify,
    i18n,
    // firebase: firebase(),
    render: h => h(App)
  }).$mount('#app');
})();

// イベント設定用関数
function noScroll(event) {
  event.preventDefault()
}

// スクロール禁止
Vue.prototype.$noScroll = function () {
  // SP
  document.addEventListener('touchmove', noScroll, {
    passive: false
  })
  // PC
  document.addEventListener('mousewheel', noScroll, {
    passive: false
  })
}

// スクロール禁止を解除
Vue.prototype.$returnScroll = function () {
  // SP
  document.removeEventListener('touchmove', noScroll, {
    passive: false
  })
  // PC
  document.removeEventListener('mousewheel', noScroll, {
    passive: false
  })
}

//jqueryを使えるように
import jQuery from 'jquery'
global.jquery = jQuery
global.$ = jQuery
window.$ = window.jQuery = require('jquery')

// // 画面遷移のたびに fire() でログを送信
// router.afterEach((to, from) => {
//   // to.path, from.path を "home|draw|catalog|..." にマップする関数を用意
//   const mapScreen = (path) => {
//     if (path.includes('/draw-penguin')) return 'draw';
//     if (path.endsWith('/list')) return 'catalog';
//     if (path.endsWith('/form')) return 'home';
//     return 'other';
//   };

//   fire('nav_click', {
//     from: mapScreen(from.path),
//     to: mapScreen(to.path),
//     source: 'router'   // UI由来ではないので router と明示
//   });
// });